module.exports = __webpack_public_path__ + "img/casetop.22768c29.jpg";